import React from "react";
import { useLoader } from "../context/LoaderContext";

const Loader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(15, 23, 42, 0.45)",
        backdropFilter: "blur(4px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        animation: "fadeIn 0.2s ease-out",
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: "50%",
          border: "4px solid rgba(16, 185, 129, 0.2)",
          borderTopColor: "var(--accent, #10B981)",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <p
        style={{
          marginTop: 16,
          color: "#fff",
          fontSize: "0.95rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          textShadow: "0 2px 4px rgba(0,0,0,0.4)",
        }}
      >
        Loading, please wait...
      </p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loader;
